
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Minus, Plus } from "lucide-react";

interface QuantityControlProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
  showLabel?: boolean;
  className?: string;
}

export const QuantityControl = ({ 
  value, 
  onChange, 
  min = 1, 
  max = 999, 
  label,
  showLabel = true,
  className = ""
}: QuantityControlProps) => {
  const handleDecrease = () => {
    const newValue = Math.max(min, value - 1);
    onChange(newValue);
  };

  const handleIncrease = () => {
    const newValue = Math.min(max, value + 1);
    onChange(newValue);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value) || min;
    onChange(Math.max(min, Math.min(max, newValue)));
  };

  return (
    <div className={className}>
      {showLabel && label && (
        <label className="block text-sm font-medium mb-2">{label}</label>
      )}
      <div className="flex items-center gap-1">
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={handleDecrease}
          disabled={value <= min}
          className="h-8 w-8 flex-shrink-0"
        >
          <Minus className="w-3 h-3" />
        </Button>
        <Input
          type="number"
          value={value}
          onChange={handleInputChange}
          min={min}
          max={max}
          className="text-center h-8 w-16"
        />
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={handleIncrease}
          disabled={value >= max}
          className="h-8 w-8 flex-shrink-0"
        >
          <Plus className="w-3 h-3" />
        </Button>
      </div>
    </div>
  );
};
